/**
 * Get the application version from environment variable
 * @returns The version string injected at build time
 */
export const getAppVersion = (): string => process.env.NEXT_PUBLIC_APP_VERSION || '0.0.0';

/**
 * Get the environment-specific version for Datadog
 * @returns The version string that matches the sourcemap upload version
 */
export const getEnvironmentVersion = (): string =>
	// Use the version set by the build process, which already includes commit hash for non-prod
	getAppVersion();
